import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import { ROUTES } from './router'
import store from "./core/services/store";
import ApiService from "./core/services/api.service";
import directive from '@/directive/index';
// import MockService from "./core/mock/mock.service";
// import { VERIFY_AUTH } from "./core/services/store/auth.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "./core/plugins/vue-i18n";
import vuetify from "./core/plugins/vuetify";
import "./core/plugins/portal-vue";
import "./core/plugins/bootstrap-vue";
import "./core/plugins/perfect-scrollbar";
import "./core/plugins/highlight-js";
import "./core/plugins/inline-svg";
import "./core/plugins/apexcharts";
import "./core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import { addLeftMenu } from "@/util/index.js"
import { getRefreshToken } from '@/core/services/jwt.service'
import { addLeftMenu } from "@/util/index.js"
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import { MENUS, GET_USER } from "@/core/services/store/auth";
import 'ant-design-vue/dist/antd.css';
Vue.config.devtools = true;
// API service init
ApiService.init();
Object.keys(directive).forEach((item) => {
  Vue.directive(item, directive[item]);
});
// Remove this to disable mock API
// MockService.init();

const whiteList = ['/login', '/404', '/error/error-2'];

// router.beforeEach((to, from, next) => {
//   var auth = store.state.auth;
//   if (whiteList.indexOf(to.path) === -1) {
//     store.dispatch(SET_BREADCRUMB, [
//       { title: to.meta.propName, route: to.name },
//       { title: to.name }
//     ]);
//   }
//   if (!auth.leftMenu.length) {
//     addLeftMenu(1, (routers, leftMenus) => {
//       Vue.nextTick(() => {
//         router.addRoutes(routers);
//         next(`${leftMenus[0].children ? leftMenus[0].path + '/' + leftMenus[0].children[0].path : leftMenus[0].path}`);
//       })
//     })

//   } else {
//     next();
//   }
// })
const GETPATH = (to, leftMenus) => {
  var path;
  switch (true) {
    case to.path !== '/':
      path = to.path
      break;
    case !leftMenus[0].children:
      path = `/${leftMenus[0].url}`;
      break;
    default:
      path = `/${leftMenus[0].url}/${leftMenus[0].children[0].url}`
      break;
  }
  return path;
}
router.beforeEach((to, from, next) => {
  var token = getRefreshToken(), auth = store.state.auth;
  if (whiteList.indexOf(to.path) === -1) {
    store.dispatch(SET_BREADCRUMB, [
      { title: to.meta.propName, route: to.name },
      { title: to.name }
    ]);
  }
  if (token && whiteList.indexOf(to.path) === -1) {
    if (to.path !== '/login' && !Object.values(auth.userInfo).length) {
      store.dispatch(GET_USER);
    }
    if (to.path !== '/login' && !auth.headerMenus.length) {
      store.dispatch(MENUS).then((headerMenus = []) => {
        addLeftMenu(headerMenus[0].clientId, (routers, leftMenus) => {
          Vue.nextTick(() => {
            router.addRoutes(routers);

            next(GETPATH(to, leftMenus));
          })
        })
      })
    } else {
      next();
    }
  } else if (whiteList.indexOf(to.path) !== -1) {
    // 在免登录白名单，直接进入
    next();
  } else {
    next({ path: '/login', query: { redirect: to.fullPath } });
  }
  // Ensure we checked auth before each page load.
  // Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // reset config to initial state

  store.dispatch(RESET_LAYOUT_CONFIG);
  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
